import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const DisableSalesTaxModal = (param)=>{
    let { dismissModal, onConfirm } = param;
    const { t } = useLocaleKeys('pages.salesTaxSettings.disableModal');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: t.title(),
        content: /*#__PURE__*/ _jsx(Typography, {
            children: t.body()
        }),
        onPrimaryButtonClick: ()=>{
            onConfirm();
            dismissModal();
        },
        onSecondaryButtonClick: dismissModal,
        primaryButtonLabel: t.disable(),
        secondaryButtonLabel: t.cancel(),
        skin: "danger",
        bi: {
            primaryButton: {
                name: 'sales_tax_disable_confirm'
            },
            secondaryButton: {
                name: 'sales_tax_disable_cancel'
            }
        }
    });
};
